import { lazy } from 'react'

import {
  USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC,
  ROLE_EXTERNAL_EDITOR,
} from 'services/user'

const CheckRedirectsPage = lazy(() => import('pages/check-redirects'))

const Dashboard = lazy(() => import('pages/dashboard'))

const Reporting = lazy(() => import('pages/reporting'))

const Campaigns = lazy(() => import('pages/campaign'))
const CommerceContent = lazy(() => import('pages/campaign/section-commerce-content'))
const CommerceContentAdd = lazy(() => import('pages/campaign/section-commerce-content/page-create'))
const PriceBox = lazy(() => import('pages/campaign/section-price-box'))
const CreatePricebox = lazy(() => import('pages/campaign/section-price-box/page-create'))
const SavePricebox = lazy(() => import('pages/campaign/section-price-box/page-save'))
const Carousel = lazy(() => import('pages/campaign/section-carousel'))
const CreateManualCarousel = lazy(() => import('pages/campaign/section-carousel/page-manual-create'))
const CreateAutomaticCarousel = lazy(() => import('pages/campaign/section-carousel/page-automatic-create'))
const SaveCarousel = lazy(() => import('pages/campaign/section-carousel/page-save'))

const IA = lazy(() => import('pages/ia'))
const GenerateContent = lazy(() => import('pages/ia/section-generate-content'))
const CreateAIContent = lazy(() => import('pages/ia/section-generate-content/page-create'))
const EditAIContent = lazy(() => import('pages/ia/section-generate-content/page-edit'))
const GenerateProductDescriptions = lazy(() => import('pages/ia/section-generate-product-descriptions'))
const CreateProductDescription = lazy(() => import('pages/ia/section-generate-product-descriptions/page-create'))
const EditProductDescriptions = lazy(() => import('pages/ia/section-generate-product-descriptions/page-edit'))

const LiveShop = lazy(() => import('pages/live-shop'))
const LiveCampaigns = lazy(() => import('pages/live-campaigns'))
const StatisticsPage = lazy(() => import('pages/live-campaigns/page-statistics'))

const Catalog = lazy(() => import('pages/catalog'))
const BrandsCatalog = lazy(() => import('pages/catalog/section-brands-catalog'))
const ExclusiveProducts = lazy(() => import('pages/catalog/section-exclusive-products'))

const Tools = lazy(() => import('pages/tools'))
const LinkGenerator = lazy(() => import('pages/tools/section-link-generator'))
const Uploads = lazy(() => import('pages/tools/section-uploads'))
const BrokenLinks = lazy(() => import('pages/tools/section-broken-links'))
const AffiliableLinks = lazy(() => import('pages/tools/section-affiliable-links'))

const Documentation = lazy(() => import('pages/documentation'))
const AffiliateScript = lazy(() => import('pages/documentation/section-affiliate-script'))
const SectionAffiliateScriptV2 = lazy(() => import('pages/documentation/section-affiliate-script-v2'))
const ScriptLiveShopping = lazy(() => import('pages/documentation/section-script-live-shopping'))
const InsertPriceBox = lazy(() => import('pages/documentation/section-insert-price-box'))
const InsertCarousel = lazy(() => import('pages/documentation/section-insert-carousel'))

const Admin = lazy(() => import('pages/admin'))
const Tags = lazy(() => import('pages/admin/section-tags'))
const TagsAdd = lazy(() => import('pages/admin/section-tags/add.tag'))
const TagsEdit = lazy(() => import('pages/admin/section-tags/edit.tags'))
const BrandList = lazy(() => import('pages/admin/section-brands'))
const BrandsAdd = lazy(() => import('pages/admin/section-brands/add.brand'))
const ProgramList = lazy(() => import('pages/admin/section-programs'))
const ProgramsAdd = lazy(() => import('pages/admin/section-programs/add.program'))
const ProgramUniqueList = lazy(() => import('pages/admin/section-programs/programs-unique'))
const ProgramsUniqueAdd = lazy(() => import('pages/admin/section-programs//programs-unique/add.program'))
const ClientList = lazy(() => import('pages/admin/section-clients'))
const ClientsAdd = lazy(() => import('pages/admin/section-clients/add.client'))
const UserList = lazy(() => import('pages/admin/section-users'))
const UsersAdd = lazy(() => import('pages/admin/section-users/add.user'))
const Products = lazy(() => import('pages/admin/section-products'))
const ProductsAdd = lazy(() => import('pages/admin/section-products/add.product'))
const ProductsEdit = lazy(() => import('pages/admin/section-products/edit.product'))

const SiteData = lazy(() => import('pages/site'))
const UserAccount = lazy(() => import('pages/user-account'))

const Login = lazy(() => import('pages/login'))
const Logout = lazy(() => import('pages/logout'))
const ForgotPassword = lazy(() => import('pages/forgot-password'))
const NotFound = lazy(() => import('pages/not-found'))
const Register = lazy(() => import('pages/register'))
const ChangeForgotPassword = lazy(() => import('pages/change-forgot-password'))
const CreatePassword = lazy(() => import('pages/change-forgot-password'))

const CRM = lazy(() => import('pages/crm'))
const NativeShop = lazy(() => import('pages/native-shop'))
const AffiliableLinkDetails = lazy(() => import('pages/tools/section-affiliable-links/Details'))

const ElisaTest = lazy(() => import('pages/elisa-test'))

const routes = {
  // Home -------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  dashboard: {
    component: Dashboard,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/',
  },
  //-------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------

  // Site -------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  checkRedirects: {
    component: CheckRedirectsPage,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/check-redirects',
  },
  // ------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  // Site -------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  siteData: {
    component: SiteData,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/site',
  },
  // ------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  // Informes ---------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------
  reporting: {
    component: Reporting,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/reports',
  },
  //-------------------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------

  // Campañas --------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------------

  // Articles
  campaignsCommerceContent: {
    component: CommerceContent,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/commerce-content',
  },
  campaignsCommerceContentAdd: {
    component: CommerceContentAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/commerce-content/add',
  },
  campaignsCommerceContentEdit: {
    component: CommerceContentAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/commerce-content/edit/:id',
    mainUrl: '/campaigns/commerce-content/edit',
  },
  // Price box
  campaignsPriceBox: {
    component: PriceBox,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/price-box',
  },
  campaignsPriceBoxAdd: {
    component: CreatePricebox,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/price-box/create',
  },
  campaignsPriceBoxSave: {
    component: SavePricebox,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/price-box/create/:id',
    mainUrl: '/campaigns/price-box/create',
  },
  campaignsPriceBoxEdit: {
    component: CreatePricebox,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/price-box/edit/:id',
    mainUrl: '/campaigns/price-box/edit',
  },
  // Carousel
  campaignsCarousel: {
    component: Carousel,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/carousel',
  },
  campaignsManualCarouselAdd: {
    component: CreateManualCarousel,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/manual-carousel/create',
  },
  campaignsManualCarouselEdit: {
    component: CreateManualCarousel,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/manual-carousel/edit/:id',
    mainUrl: '/campaigns/manual-carousel/edit',
  },
  campaignsAutomaticCarouselAdd: {
    component: CreateAutomaticCarousel,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/automatic-carousel/create',
  },
  campaignsAutomaticCarouselEdit: {
    component: CreateAutomaticCarousel,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/automatic-carousel/edit/:id',
    mainUrl: '/campaigns/automatic-carousel/edit',
  },
  campaignsManualCarouselSave: {
    component: SaveCarousel,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns/carousel/create/:id',
    mainUrl: '/campaigns/carousel/create',
  },
  // Base
  campaigns: {
    component: Campaigns,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/campaigns',
  },
  //-------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  // AI ---------------------------------------------------------------------------
  // -------------------------------------------------------------------------------
  // IA Generate Content
  generateContent: {
    component: GenerateContent,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/ia/generate-content',
  },
  createAIContent: {
    component: CreateAIContent,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/ia/generate-content/create',
  },
  editAIContent: {
    component: EditAIContent,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/ia/generate-content/edit/:id',
    mainUrl: '/ia/generate-content/edit/',
  },
  // IA Generate Product Descriptions
  generateProductDescriptions: {
    component: GenerateProductDescriptions,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/ia/generate-product-descriptions',
  },
  createProductDescription: {
    component: CreateProductDescription,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/ia/generate-product-descriptions/create',
  },
  editProductDescriptions: {
    component: EditProductDescriptions,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/ia/generate-product-descriptions/edit/:id',
    mainUrl: '/ia/generate-product-descriptions/edit/',
  },
  // Base
  ia: {
    component: IA,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/ia',
  },
  //--------------------------------------------------------------------------------
  // --------------------------------------------------------------------------------

  // LiveShopping ----------------------------------------------------------------
  // ------------------------------------------------------------------------------
  liveShop: {
    component: LiveShop,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_ANALYTIC],
    path: '/liveshop/:id',
    mainUrl: '/liveshop',
  },
  liveCampaigns: {
    component: LiveCampaigns,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_ANALYTIC],
    path: '/live-campaigns',
  },
  liveCampaign_statisticsPage: {
    component: StatisticsPage,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_ANALYTIC],
    path: '/live-campaigns/statistics/:id',
    mainUrl: '/live-campaigns/statistics',
  },
  //--------------------------------------------------------------------------------
  // --------------------------------------------------------------------------------

  // Catálogo ----------------------------------------------------------------------
  // --------------------------------------------------------------------------------
  // Brands Catalog
  brandsCatalog: {
    component: BrandsCatalog,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/catalog/brands',
  },
  // Exclusive Products
  exclusiveProducts: {
    component: ExclusiveProducts,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/catalog/exclusive-products',
  },
  // Base
  catalog: {
    component: Catalog,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC, ROLE_EXTERNAL_EDITOR],
    path: '/catalog',
  },
  //---------------------------------------------------------------------------
  // --------------------------------------------------------------------------------

  // Herramientas -------------------------------------------------------------
  // --------------------------------------------------------------------------------
  // Create Links
  linkGenerator: {
    component: LinkGenerator,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/tools/create-link',
  },
  // Upload Amazon Files
  uploads: {
    component: Uploads,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_ANALYTIC],
    path: '/tools/uploads',
  },
  // Affiliable Links
  affiliableLinks: {
    component: AffiliableLinks,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/tools/affiliate-links',
  },
  affiliableLinkDetails: {
    component: AffiliableLinkDetails,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/tools/affiliate-links/:id',
    mainUrl: '/tools/affiliate-links',
  },
  // Broken Links
  brokenLinks: {
    component: BrokenLinks,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/tools/broken-links',
  },
  // Base
  tools: {
    component: Tools,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/tools',
  },
  //------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------

  // Documentación ---------------------------------------------------------------------
  // ------------------------------------------------------------------------------------
  // DOC Affiliate Script
  affiliate_script: {
    component: AffiliateScript,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/documentation/affiliate-script',
  },
  // DOC Affiliate Script V2
  affiliate_script_v2: {
    component: SectionAffiliateScriptV2,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/documentation/v2-affiliate-script',
  },
  // DOC Script Live Shopping
  script_live_shopping: {
    component: ScriptLiveShopping,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/documentation/script-live-shopping',
  },
  // DOC Insert Price Box
  insertPriceBox: {
    component: InsertPriceBox,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/documentation/insert-price-box',
  },
  // DOC Insert Carousel
  insertCarousel: {
    component: InsertCarousel,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/documentation/insert-carousel',
  },
  // Base
  documentation: {
    component: Documentation,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/documentation',
  },
  //--------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  // Admin-------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  // Admin Categories
  tags: {
    component: Tags,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/categories',
  },
  tagsAdd: {
    component: TagsAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/categories/add',
  },
  tagsEdit: {
    component: TagsEdit,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/categories/:id',
    mainUrl: '/admin/categories',
  },
  // Admin Brands
  brands: {
    component: BrandList,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/brands',
  },
  brandsAdd: {
    component: BrandsAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/brands/add',
  },
  brandsEdit: {
    component: BrandsAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/brands/:id',
    mainUrl: '/admin/brands',
  },
  // Admin Programs
  programs: {
    component: ProgramList,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/programs',
  },
  programsAdd: {
    component: ProgramsAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/programs/add',
  },
  programsEdit: {
    component: ProgramsAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/programs/:id',
    mainUrl: '/admin/programs',
  },
  // Admin Unique Links
  programsUnique: {
    component: ProgramUniqueList,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/links',
  },
  programsUniqueAdd: {
    component: ProgramsUniqueAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/links/add',
  },
  programsUniqueEdit: {
    component: ProgramsUniqueAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/links/:id',
    mainUrl: '/admin/links',
  },
  // Admin Clients
  clients: {
    component: ClientList,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/clients',
  },
  clientsAdd: {
    component: ClientsAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/clients/add',
  },
  clientsEdit: {
    component: ClientsAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/clients/:id',
    mainUrl: '/admin/clients',
  },
  // Admin Users
  users: {
    component: UserList,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/users',
  },
  usersAdd: {
    component: UsersAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/users/add',
  },
  usersEdit: {
    component: UsersAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/users/:id',
    mainUrl: '/admin/users',
  },
  // Admin Products
  products: {
    component: Products,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/products',
  },
  productsAdd: {
    component: ProductsAdd,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/products/add',
  },
  productsEdit: {
    component: ProductsEdit,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin/products/:id',
    mainUrl: '/admin/products',
  },
  // Base
  admin: {
    component: Admin,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/admin',
  },
  //------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  // Usuarios --------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  userAccount: {
    component: UserAccount,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/users/account',
  },
  userManagement: {
    component: UserAccount,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_ANALYTIC],
    path: '/users/management',
  },
  //------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  // Register --------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  register: {
    component: Register,
    isPublic: true,
    requiredRoles: [],
    path: '/sign-up',
  },
  //-------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  // Login ------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  login: {
    component: Login,
    isPublic: true,
    requiredRoles: [],
    path: '/sign-in',
  },
  //-------------------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------

  // Logout -----------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------
  logout: {
    component: Logout,
    isPublic: true,
    requiredRoles: [USER_TYPE_ADMIN, ROLE_ADMINISTRATOR, ROLE_REDACTOR, ROLE_ANALYTIC],
    path: '/logout',
  },
  //-------------------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------

  // Password ---------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------
  changeForgotPassword: {
    component: ChangeForgotPassword,
    isPublic: true,
    requiredRoles: [],
    path: '/password-reset',
  },
  createPassword: {
    component: CreatePassword,
    isPublic: true,
    requiredRoles: [],
    path: '/password-create',
  },
  forgotPassword: {
    component: ForgotPassword,
    isPublic: true,
    requiredRoles: [],
    path: '/password-recovery',
  },
  //--------------------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------

  // Not Found (404) ---------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------
  notFound: {
    component: NotFound,
    isPublic: true,
    requiredRoles: [],
    path: '/not-found',
  },
  //--------------------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------

  // Pendientes --------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------
  nativeShop: {
    component: NativeShop,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/nativeshop',
  },

  crm: {
    component: CRM,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/crm',
  },
  //--------------------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------

  // Test ocultos ------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------
  elisaTest: {
    component: ElisaTest,
    isPublic: false,
    requiredRoles: [USER_TYPE_ADMIN],
    path: '/elisa-test-nunca-me-veran',
  },
  //--------------------------------------------------------------------------------------------
  // -------------------------------------------------------------------------------------------
}

export default routes
